// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 926) return "css/core.926.590ca1d9394327d2f0a9.main.css";
	if (chunkId === 179) return "css/core.main.d60a9c7bf18c48b64ef3.main.css";
	// return url for filenames based on template
	return "css/core.chunk." + {"405":"cfd","654":"trader","809":"account"}[chunkId] + "." + {"405":"679f5771fac985b270c9","654":"4ba5ac5477b90a2d625a","809":"eabb36815597eaa8922d"}[chunkId] + ".css";
};